import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { SectionHeading } from './SectionHeading';
import type { RelatedProduct } from '../../types/product';
type RelatedProductsProps = {
  heading: string;
  subheading: string;
  items: RelatedProduct[];
};
export function RelatedProducts({
  heading,
  subheading,
  items
}: RelatedProductsProps) {
  return <section className="w-full bg-white py-20" aria-labelledby="related-heading" data-id="element-1244" data-mp="3vi7l8vbidezl">
      <div className="mx-auto max-w-shell px-6" data-id="element-1245" data-mp="3ey7ma58cylc">
        <SectionHeading id="related-heading" title={heading} subtitle={subheading} data-id="element-1246" data-mp="3dn3uabsbqu8" />
        <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1247" data-mp="3lji1sy3yrmh8">
          {items.map(item => {
          const Icon = item.icon;
          return <li key={item.title} data-id="element-1248" data-mp="2a4v2daowx2f1">
                <SmartLink href={item.href} className="group flex h-full flex-col rounded-[14px] border border-canvas-line bg-white p-6 transition-colors duration-150 ease-out hover:border-brand/30 hover:bg-canvas-sky" data-id="element-1249" data-mp="2a3tda2b2afeb">
                  <span className="flex h-10 w-10 items-center justify-center rounded-[9px] border border-canvas-line bg-white text-ink transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-1250" data-mp="2mbdtnflvqalp">
                    <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-1251" data-mp="2vb0qrp7ksu8y" />
                  </span>
                  <h3 className="mt-5 text-[17px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1252" data-mp="399idpkpnq2pt">{item.title}</h3>
                  <p className="mt-2 text-[14px] leading-[1.5] text-ink-muted" data-id="element-1253" data-mp="3597w1asi5nv4">{item.copy}</p>
                  <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[14px] font-medium text-brand" data-id="element-1254" data-mp="3j0d32xy79ifh">
                    Explore {item.title}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1255" data-mp="3syj1v6opm8g4" />
                  </span>
                </SmartLink>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}